import { createContext, useReducer } from "react";
import * as types from "./types";

const initialState = {
  auditList: {},
  query: {},
  auditDetail: null,
  auditErrorCode: "",
  isCameraPermissionChecked : false
};

const userReducer = (state, action) => {
  switch (action.type) {
    case types.GET_AUDIT_LISTING:
      return {
        ...state,
        auditList: action.payload,
      };
    case types.SET_AUDIT_QUESTIONNAIRE_DETAIL:
      return {
        ...state,
        auditDetail: action.payload,
      };
    case types.SET_QUERY:
      return {
        ...state,
        query: action.payload,
      };
    case types.SET_ERROR_CODE:
      return {
        ...state,
        auditErrorCode: action.payload,
      };
    case types.SET_MULTIPLE_CAMERA:
      return {
        ...state,
        isMultipleCamera: action.payload,
        isCameraPermissionChecked: true
      };
    default:
      return state;
  }
};

export const AuditContext = createContext(initialState);

const AuditProvider = ({ children }) => {
  const [auditState, auditDispatch] = useReducer(userReducer, initialState);

  return (
    <AuditContext.Provider value={[auditState, auditDispatch]}>
      {children}
    </AuditContext.Provider>
  );
};

export default AuditProvider;
